module.exports = __webpack_public_path__ + "static/5da4b68436bbb663eb6ae4baf0cda9ba8e0c80dc3ed594906c53f8ec2faa7cf6-7299b8c4d4b79a7620f3f4780a86f062.png";